/* src/app/admin-dashboard/coffee-machines/coffee-machines.component.css */
.cm-table td {
  vertical-align: middle;
}
.cm-id {
  color: #6b7280;
  font-size: 12px;
}
.cm-muted {
  color: #9ca3af;
}
.cm-unset {
  background: rgba(245, 158, 11, 0.08);
}
.cm-off td:not(:first-child):not(:nth-child(2)):not(:nth-child(3)):not(:nth-child(4)) {
  opacity: 0.75;
}
.cm-select {
  width: 200px;
}
.cm-reason {
  width: 160px;
  margin-left: 8px;
}
.cm-types {
  white-space: nowrap;
}
.cm-types mat-checkbox {
  margin-right: 8px;
}
.cm-actions {
  white-space: nowrap;
}
.cm-error {
  color: #b91c1c;
  font-size: 12px;
  margin-top: 4px;
}
/*# sourceMappingURL=coffee-machines.component.css.map */
